import axios from "axios";

// create an axios instance
const service = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API, // api 的 base_url
  timeout: 1000000 // request timeout
});

// // request interceptor
// service.interceptors.request.use(
//   config => {
//     // Do something before request is sent
//     if (store.getters.token) {
//       // 让每个请求携带token-- ['X-Litemall-Admin-Token']为自定义key 请根据实际情况自行修改
//       config.headers["Authorization"] = getToken();
//     }
//     return config;
//   },
//   error => {
//     // Do something with request error
//     console.log(error); // for debug
//     Promise.reject(error);
//   }
// );

// // response interceptor
// service.interceptors.response.use(
//   response => {
//     const res = response.data;

//     if (res.status === 401) {
//       // to re-login
//       MessageBox.confirm("Token已失效，请重新登录", "确认登出", {
//         confirmButtonText: "重新登录",
//         type: "warning"
//       }).then(() => {
//         store.dispatch("resetToken").then(() => {
//           location.reload();
//         });
//       });
//     } else if (res.status === 404) {
//       Message({
//         message: "Not Found!",
//         type: "error",
//         duration: 5 * 1000
//       });
//       return Promise.reject(res);
//     } else if (res.status !== 200) {
//       // 非200的错误属于业务错误，留给具体页面处理
//       return Promise.reject(res);
//     } else {
//       return Promise.resolve(res);
//     }
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );

export default service;
